"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var StreamTypes = _interopRequireWildcard(require("../../definitions/StreamTypes"));

var Log = _interopRequireWildcard(require("../util/Log"));

var _cache = _interopRequireDefault(require("../util/cache"));

var DataSync = _interopRequireWildcard(require("../util/DataSync"));

var _Media = _interopRequireDefault(require("../util/Media"));

var _constants = require("../util/constants");

var Events = _interopRequireWildcard(require("../../definitions/Events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _facingModes = [_Media.default.facingMode.USER, _Media.default.facingMode.ENVIRONMENT];

var _getConstraintValue = function _getConstraintValue(constraints, prop) {
  return constraints[prop].exact || constraints[prop].ideal || constraints[prop];
};
/* eslint-disable no-param-reassign */


var _setConstrainValue = function _setConstrainValue(constraints, prop, other, value) {
  constraints[prop] = {
    exact: value
  };
  delete constraints[other];
};
/* eslint-enable no-param-reassign */

/**
 * The local stream
 */


var Local =
/*#__PURE__*/
function () {
  /**
   * @access protected
   * @param {object} values
   */
  function Local(values) {
    _classCallCheck(this, Local);

    /**
     * The uid of the room the stream is published in
     * @type {string}
     */
    this.roomId = values.roomId;
    /**
     * The uid of this stream
     * @type {string}
     */

    this.uid = values.uid;
    /**
     * The type of the stream
     * @type {string}
     */

    this.type = values.type;
    /**
     * Indicates if a track is muted
     * @type {{audio: boolean, video: boolean}}
     */

    this.muted = Object.assign({
      audio: false,
      video: false
    }, values.muted);
    /**
     * The local DOM container element where the {@link Local~media} is displayed
     * @type {Element}
     */

    this.container = values.container || _cache.default.config.localStreamContainer;
    /**
     * The local DOM media element where the {@link Local~media} is displayed
     * @type {Element}
     */

    this.node = null;
    /**
     * List of the PeerConnections associated to this local stream
     * @type {PeerConnection[]}
     */

    this.peerConnections = [];
    /**
     * Local stream status
     * @type {string}
     */

    this.status = _constants.NONE;
    /**
     * is the video is loaded int the local DOM media element
     * @type {boolean}
     */

    this.isVideoLoaded = false;
    /**
     * @access private
     * @type {{audio: string, video: string}}
     */

    this._inputs = {}; // Set constraints

    this.constraints = values.constraints;
    /**
     * List of callbacks for Local
     * @type object
     * @private
     */

    this._callbacks = {};
  }
  /**
   * Register a callback for a specific event
   * @param {string} event The event name ({@link Events/Stream})
   * @param {function} callback The callback for the event
   */


  _createClass(Local, [{
    key: "on",
    value: function on(event, callback) {
      if (Events.local.supports(event)) {
        if (!this._callbacks[event]) {
          this._callbacks[event] = [];
        }

        this._callbacks[event].push(callback);
      }
    }
    /**
     * Register a callback for a specific event
     * @param {string} [event] The event name ({@link Events/Stream})
     * @param {function} [callback] The callback for the event
     */

  }, {
    key: "off",
    value: function off(event, callback) {
      if (!event) {
        this._callbacks = {};
      } else if (Events.local.supports(event)) {
        if (!callback) {
          this._callbacks[event] = [];
        } else {
          this._callbacks[event] = this._callbacks[event].filter(function (cb) {
            return cb !== callback;
          });
        }
      }
    }
    /**
     * The Media Constraints. (defaults to global config)
     * @param {MediaConstraints} constraints
     */

  }, {
    key: "updateConstraints",

    /**
     * Updates the stream constraints and retrieve the new MediaStream
     * @param constraints
     * @returns {*|Promise.<TResult>}
     */
    value: function updateConstraints(constraints) {
      var _this = this;

      Log.d('Local~updateConstraints', constraints);
      this.constraints = constraints;
      return navigator.mediaDevices.getUserMedia(this.constraints).catch(function (e) {
        (_this._callbacks[Events.local.WEBRTC_ERROR] || []).forEach(function (cb) {
          return cb(e);
        });
        return e;
      }).then(function (media) {
        ['audio', 'video'].forEach(function (kind) {
          var constraintsValue = _this.constraints[kind];

          if (constraintsValue) {
            if (constraintsValue.deviceId || constraintsValue.facingMode) {
              _this._inputs[kind] = _getConstraintValue(constraintsValue, constraintsValue.facingMode ? 'facingMode' : 'deviceId');
            }
          }
        });
        _this.media = media;
      });
    }
    /**
     * The associated MediaStream
     * @type {MediaStream}
     */

  }, {
    key: "mute",

    /**
     * Mute a track of a Stream
     * @param {string} [track=AUDIO] The track to mute. (AUDIO, VIDEO, AUDIO_VIDEO)
     * @param {boolean} [state=true] true for mute & false for un-mute
     * @example <caption>mute video</caption>
     * stream.mute(Reach.t.VIDEO)
     * @example <caption>mute audio</caption>
     * stream.mute(Reach.t.AUDIO)
     * // or
     * stream.mute()
     */
    value: function mute() {
      var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StreamTypes.AUDIO;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      Log.d('mute', track, state);
      var _this$muted = this.muted,
          audio = _this$muted.audio,
          video = _this$muted.video;
      var tracks;

      switch (track) {
        case StreamTypes.AUDIO:
          audio = state;
          tracks = this.media.getAudioTracks();
          break;

        case StreamTypes.VIDEO:
        case StreamTypes.SCREEN_SHARING:
          video = state;
          tracks = this.media.getVideoTracks();
          break;

        case StreamTypes.AUDIO_VIDEO:
          audio = state;
          video = state;
          tracks = this.media.getTracks();
          break;

        default:
          break;
      } // Mute media tracks


      tracks.forEach(function (track) {
        // eslint-disable-line no-shadow
        track.enabled = !state; // eslint-disable-line no-param-reassign
      }); // Signal subscribers

      this.muted = {
        audio: audio,
        video: video
      };
      DataSync.set("_/rooms/".concat(this.roomId, "/streams/").concat(this.uid, "/muted"), this.muted);
    }
    /**
     * Un-mute a track of a Stream
     * @param {string} [track=AUDIO] The track to mute. (AUDIO, VIDEO, AUDIO_VIDEO)
     * @example <caption>Un-mute video</caption>
     * stream.unMute(Reach.t.VIDEO)
     * @example <caption>Un-mute audio</caption>
     * stream.unMute(Reach.t.AUDIO)
     * // or
     * stream.unMute()
     */

  }, {
    key: "unMute",
    value: function unMute(track) {
      this.mute(track, false);
    }
    /**
     * Removes stream for published list, closes associated
     * PeerConnections and stops current MediaStream
     * @returns {Promise}
     */

  }, {
    key: "close",
    value: function close() {
      if (!~[_constants.CLOSED, _constants.CLOSING].indexOf(this.status)) {
        // eslint-disable-line no-bitwise
        this.status = _constants.CLOSING; // Stop listening to Subscribers

        var path = "_/rooms/".concat(this.roomId, "/subscribers/").concat(this.uid);
        DataSync.off(path, 'child_added');
        DataSync.off(path, 'child_removed'); // Cancel onDisconnects

        DataSync.onDisconnect("_/rooms/".concat(this.roomId, "/streams/").concat(this.uid)).cancel();
        DataSync.onDisconnect("_/rooms/".concat(this.roomId, "/subscribers/").concat(this.uid)).cancel(); // Remove subscribers

        DataSync.remove(path); // Remove stream

        DataSync.remove("_/rooms/".concat(this.roomId, "/streams/").concat(this.uid));
        this.media = null; // Close

        this.status = _constants.CLOSED;
      }

      return Promise.resolve(this.status);
    }
    /**
     * Switch video input device
     * @param {string} [deviceId] A video input device Id or the `facingMode` value
     * @returns {Promise<Local, Error>}
     */

  }, {
    key: "switchCamera",
    value: function switchCamera(deviceId) {
      return this._switchDevice(StreamTypes.VIDEO, deviceId);
    }
    /**
     * Switch audio input device
     * @param {string} [deviceId] A audio input device Id
     * @returns {Promise<Local, Error>}
     */

  }, {
    key: "switchMicrophone",
    value: function switchMicrophone(deviceId) {
      return this._switchDevice(StreamTypes.AUDIO, deviceId);
    }
    /**
     * Switch input device
     * @access private
     * @param {string} kind The kind of device to switch
     * @param {string} [deviceId] An input device id
     * @returns {Promise<Local, Error>}
     */

  }, {
    key: "_switchDevice",
    value: function _switchDevice(kind, deviceId) {
      var _this2 = this;

      Log.d('Local~_switchDevice', kind, deviceId);

      if (this.media.getTracks().some(function (track) {
        return track.kind === kind;
      })) {
        var next = Promise.resolve(deviceId);

        var currentModeIdx = _facingModes.indexOf(this._inputs[kind]);

        if (!deviceId && !!~currentModeIdx) {
          // eslint-disable-line no-bitwise
          // Loop facingModes
          next = Promise.resolve(_facingModes[(currentModeIdx + 1) % _facingModes.length]);
        } else if (!~_facingModes.indexOf(deviceId)) {
          // eslint-disable-line no-bitwise
          // Loop deviceIds
          next = _Media.default.devices().then(function (d) {
            // devices IDs
            var devices = d["".concat(kind, "input")].map(function (mediaDevice) {
              return mediaDevice.deviceId;
            }); // Sort to ensure same order

            devices.sort(); // New device

            var nextDevice = deviceId;

            if (deviceId && !devices.some(function (device) {
              return device === deviceId;
            })) {
              return Promise.reject(new Error("Unknown ".concat(kind, " device")));
            }

            if (!deviceId && devices.length > 1) {
              var idx = _this2._inputs[kind] ? devices.findIndex(function (v) {
                return v === _this2._inputs[kind];
              }, _this2) : 0;
              nextDevice = devices[++idx % devices.length]; // eslint-disable-line no-plusplus
            }

            return nextDevice;
          });
        } else {
          next = Promise.resolve(deviceId);
        }

        return next.then(function (device) {
          // eslint-disable-line consistent-return
          if (_this2._inputs[kind] !== device) {
            // Update video streams
            _this2._inputs[kind] = device; // Stop tracks

            _this2.media.getTracks().forEach(function (track) {
              return track.stop();
            }); // Update constraints


            var constraints = Object.assign({}, _this2.constraints);
            var props = ['facingMode', 'deviceId'];

            if (!~_facingModes.indexOf(device)) {
              // eslint-disable-line no-bitwise
              props = props.reverse();
            }

            _setConstrainValue(constraints[kind], props[0], props[1], device);

            Log.d('Local~_switchDevice', kind, constraints);
            return _this2.updateConstraints(constraints);
          }
        }).then(function () {
          return _this2;
        });
      }

      return Promise.reject(new Error("Current stream does not contain a ".concat(kind, " track")));
    }
    /**
     * Publish a local stream
     * @access protected
     * @param {string} roomId The room Id
     * @param {string} type The stream type, see {@link StreamTypes} for possible values
     * @param {?Element} container The element the stream is attached to.
     * @param {?MediaStreamConstraints} [constraints] The stream constraints.
     * If not defined the constraints defined in ReachConfig will be used.
     * @returns {Promise<Local, Error>}
     */

    /* static share(roomId, type, container, constraints) {
      if (!cache.user) {
        return Promise.reject(new Error('Only an authenticated user can share a stream.'));
      }
      const streamMetaData = {
        from: cache.user.uid,
        device: cache.device,
        type
      };
        const sharedStream = new Local(Object.assign({ roomId, constraints, container },
        streamMetaData));
      Log.d('Local~share', { sharedStream });
      return navigator.mediaDevices.getUserMedia(sharedStream.constraints)
        .then((media) => {
          sharedStream.media = media;
        })
        // Got MediaStream, publish it
        .then(() => DataSync.push(`_/rooms/${roomId}/streams`, streamMetaData))
        .then((streamRef) => {
          sharedStream.uid = streamRef.name();
          if (/video/i.test(sharedStream.type)) {
            if (sharedStream.isVideoLoaded) {
              const streamSize = {
                height: sharedStream.node.videoHeight,
                width: sharedStream.node.videoWidth,
              };
              streamRef.update(streamSize);
            } else {
              sharedStream.node.onloadeddata = function () { // eslint-disable-line func-names
                const streamSize = {
                  height: sharedStream.node.videoHeight,
                  width: sharedStream.node.videoWidth,
                };
                streamRef.update(streamSize);
              };
            }
          }
          if (/video/i.test(sharedStream.type)) {
            window.addEventListener('resize', (() => {
              if (sharedStream.node != null) {
                const streamSize = {
                  height: sharedStream.node.videoHeight,
                  width: sharedStream.node.videoWidth,
                };
                streamRef.update(streamSize);
              }
            }));
          }
          // Save sharedStream
          cache.streams.shared[sharedStream.uid] = sharedStream;
          // Remove shared stream on Disconnect
          DataSync.onDisconnect(`_/rooms/${roomId}/streams/${sharedStream.uid}`).remove();
          // Remove shared stream on Disconnect
          DataSync.onDisconnect(`_/rooms/${roomId}/subscribers/${sharedStream.uid}`).remove();
          // Start listening to subscribers
          const
            path = `_/rooms/${sharedStream.roomId}/subscribers/${sharedStream.uid}`;
            const value = snapData => Object.assign({ device: snapData.name() }, snapData.val() || {});
          DataSync.on(path, 'child_added',
            (snapData) => {
              const subscriber = value(snapData);
              Log.d('Local~subscribed', subscriber);
              cache.peerConnections.offer(sharedStream, subscriber)
                .then((pc) => {
                  (this._callbacks[Events.local.SUBSCRIBED] || [])
                    .forEach(cb => cb(sharedStream, subscriber));
                  return sharedStream.peerConnections.push(pc);
                });
            },
            Log.e.bind(Log));
          DataSync.on(path, 'child_removed',
            (snapData) => {
              const subscriber = value(snapData);
              Log.d('Local~un-subscribed', subscriber);
              const closedPC = cache.peerConnections.close(sharedStream.uid, subscriber.device);
              sharedStream.peerConnections = sharedStream.peerConnections
                .filter(pc => pc !== closedPC);
            },
            Log.e.bind(Log));
          Log.d('Local~shared', { sharedStream });
          return sharedStream;
        });
    } */

    /**
     * Get a local stream
     * @access protected
     * @param {string} roomId The room Id
     * @param {string} type The stream type, see {@link StreamTypes} for possible values
     * @param {?Element} container The element the stream is attached to.
     * @param {?MediaStreamConstraints} [constraints] The stream constraints.
     * If not defined the constraints defined in ReachConfig will be used.
     * @returns {Promise<Local, Error>}
     */

  }, {
    key: "publish",

    /**
     * Publish a local stream
     * @access protected
     * @returns {Local}
     */
    value: function publish(sharedStream) {
      var _this3 = this;

      Log.d('Local~publish');
      var roomId = sharedStream.roomId;
      return DataSync.push("_/rooms/".concat(roomId, "/streams"), sharedStream.streamMetaData).then(function (streamRef) {
        sharedStream.uid = streamRef.name(); // eslint-disable-line no-param-reassign

        if (sharedStream.isVideoLoaded) {
          var streamSize = {
            height: sharedStream.node.videoHeight,
            width: sharedStream.node.videoWidth
          };
          streamRef.update(streamSize);
        } else {
          sharedStream.node.onloadeddata = function () {
            // eslint-disable-line
            var streamSize = {
              height: sharedStream.node.videoHeight,
              width: sharedStream.node.videoWidth
            };
            streamRef.update(streamSize);
          };
        }

        window.addEventListener('resize', function () {
          if (sharedStream.node != null) {
            var _streamSize = {
              height: sharedStream.node.videoHeight,
              width: sharedStream.node.videoWidth
            };
            streamRef.update(_streamSize);
          }
        }); // Save sharedStream

        _cache.default.streams.shared[sharedStream.uid] = sharedStream; // Remove shared stream on Disconnect

        DataSync.onDisconnect("_/rooms/".concat(roomId, "/streams/").concat(sharedStream.uid)).remove(); // Remove shared stream on Disconnect

        DataSync.onDisconnect("_/rooms/".concat(roomId, "/subscribers/").concat(sharedStream.uid)).remove(); // Start listening to subscribers

        var path = "_/rooms/".concat(sharedStream.roomId, "/subscribers/").concat(sharedStream.uid);

        var value = function value(snapData) {
          return Object.assign({
            device: snapData.name()
          }, snapData.val() || {});
        };

        DataSync.on(path, 'child_added', function (snapData) {
          var subscriber = value(snapData);
          Log.d('Local~subscribed', subscriber);

          _cache.default.peerConnections.offer(sharedStream, subscriber, _this3._callbacks[Events.local.WEBRTC_ERROR]).then(function (pc) {
            (_this3._callbacks[Events.local.SUBSCRIBED] || []).forEach(function (cb) {
              return cb(sharedStream, subscriber);
            });
            return sharedStream.peerConnections.push(pc);
          });
        }, Log.e.bind(Log), _this3);
        DataSync.on(path, 'child_removed', function (snapData) {
          var subscriber = value(snapData);
          Log.d('Local~un-subscribed', subscriber);

          var closedPC = _cache.default.peerConnections.close(sharedStream.uid, subscriber.device);
          /* eslint-disable no-param-reassign */


          sharedStream.peerConnections = sharedStream.peerConnections.filter(function (pc) {
            return pc !== closedPC;
          });
          /* eslint-enable no-param-reassign */
        }, Log.e.bind(Log));
        Log.d('Local~shared', {
          sharedStream: sharedStream
        });
        return sharedStream;
      });
    }
  }, {
    key: "constraints",
    set: function set(constraints) {
      var _this4 = this;

      var values = constraints || _cache.default.config.constraints;

      var defaultConstraints = _Media.default.constraints();

      ['audio', 'video'].forEach(function (type) {
        if (!~_this4.type.indexOf(type)) {
          // eslint-disable-line no-bitwise
          values[type] = false;
        } else if (!values[type]) {
          values[type] = defaultConstraints[type];
        }

        if (values[type].deviceId || values[type].facingMode) {
          _this4._inputs[type] = _getConstraintValue(values[type], values[type].facingMode ? 'facingMode' : 'deviceId');
        }
      });
      Log.d('Local~set#contraints', values);
      /**
       * @ignore
       */

      this._constraints = values;
    }
    /**
     * The Media Constraints. (defaults to global config)
     * @type {MediaConstraints}
     */
    ,
    get: function get() {
      return this._constraints;
    }
  }, {
    key: "media",
    set: function set(mediaStream) {
      var _this5 = this;

      if (mediaStream) {
        if (!(mediaStream instanceof MediaStream)) {
          throw new Error('The media MUST be a MediaStream');
        }

        var checkDevices = {};
        mediaStream.getTracks().forEach(function (track) {
          // Reset mute
          track.enabled = !_this5.muted[track.kind]; // eslint-disable-line no-param-reassign
          // Get device label

          if (!_this5._inputs[track.kind]) {
            checkDevices[track.kind] = track.label;
          }
        }); // Try to get deviceId from label

        if (Object.keys(checkDevices).length) {
          _Media.default.devices().then(function (devices) {
            Object.keys(checkDevices).forEach(function (kind) {
              if (devices["".concat(kind, "input")]) {
                var deviceIds = devices["".concat(kind, "input")].filter(function (device) {
                  return device.label.length && device.label === checkDevices[kind];
                });

                if (deviceIds.length === 1 && !_this5._inputs[kind]) {
                  _this5._inputs[kind] = deviceIds[0].deviceId;
                }

                if (deviceIds.length === 0 && devices["".concat(kind, "input")][0].label === '' && !_this5._inputs[kind]) {
                  // from a webview, the label is not delivered
                  _this5._inputs[kind] = devices["".concat(kind, "input")][0].deviceId;
                }
              }
            });
          });
        } // Display


        this.node = _Media.default.attachStream(mediaStream, this.container, this.node, 0);

        this.node.onloadeddata = function () {
          _this5.isVideoLoaded = true;
        };

        this.status = _constants.CONNECTED;
        Log.d('Local~set media', {
          mediaStream: mediaStream
        }, this.node); // Renegotiate

        this.peerConnections.forEach(function (peerConnection) {
          return peerConnection.renegotiate(_this5._media, mediaStream);
        });
      } else if (this.media && !mediaStream) {
        // Remove node
        this.node.srcObject = null;
        this.container.removeChild(this.node);
        this.node = null; // Stop stream

        this.media.getTracks().forEach(function (track) {
          return track.stop();
        }); // Close PeerConnections

        this.peerConnections.forEach(function (peerConnection) {
          return peerConnection.close();
        });
      } // Save

      /**
       * @ignore
       */


      this._media = mediaStream;
    }
    /**
     * The associated MediaStream
     * @type {MediaStream}
     */
    ,
    get: function get() {
      return this._media;
    }
  }], [{
    key: "getLocalVideo",
    value: function getLocalVideo(roomId, type, container, constraints) {
      if (!_cache.default.user) {
        return Promise.reject(new Error('Only an authenticated user can share a stream.'));
      }

      var streamMetaData = {
        from: _cache.default.user.uid,
        device: _cache.default.device,
        userAgent: _cache.default.userAgent,
        type: type
      };
      var sharedStream = new Local(Object.assign({
        roomId: roomId,
        constraints: constraints,
        container: container
      }, streamMetaData));
      sharedStream.streamMetaData = streamMetaData;
      Log.d('Local~getLocalVideo', {
        sharedStream: sharedStream
      });
      return navigator.mediaDevices.getUserMedia(sharedStream.constraints).then(function (media) {
        sharedStream.media = media;
        return sharedStream;
      });
    }
  }]);

  return Local;
}();

exports.default = Local;